import { useEffect, useState } from 'preact/hooks';
import { currentScreen, gameSetup } from '../../App';
import { sfx } from '../../lib/sfx';

interface UniverseSummary {
  id: string;
  name: Record<string, string>;
  description: Record<string, string>;
  content_rating: string;
}

export function UniverseSelect() {
  const [universes, setUniverses] = useState<UniverseSummary[]>([]);
  const [selected, setSelected] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const lang = (gameSetup.value.language ?? 'en') as 'es' | 'en' | 'pt';

  useEffect(() => {
    fetch('/api/universes')
      .then((r) => r.json())
      .then((data) => {
        setUniverses(data.universes ?? []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  type LangKey = 'es' | 'en' | 'pt';
  const labels: Record<string, Record<LangKey, string>> = {
    title: { es: 'ELIGE TU UNIVERSO', en: 'CHOOSE YOUR UNIVERSE', pt: 'ESCOLHA SEU UNIVERSO' },
    back: { es: 'Volver', en: 'Back', pt: 'Voltar' },
    next: { es: 'Continuar', en: 'Continue', pt: 'Continuar' },
    loading: { es: 'Cargando...', en: 'Loading...', pt: 'Carregando...' },
  };
  const tr = (key: string) => labels[key]?.[lang] ?? labels[key]?.en ?? key;

  function handleConfirm() {
    if (!selected) return;
    sfx.success();
    gameSetup.value = { ...gameSetup.value, universeId: selected };
    currentScreen.value = 'genre';
  }

  return (
    <div class="center-screen">
      <div class="pixel-border container">
        <h2 class="pixel-title text-yellow mb-3 text-center" style={{ fontSize: '18px' }}>
          {tr('title')}
        </h2>

        {loading && <p class="text-dim text-center">{tr('loading')}</p>}

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {universes.map((u) => (
            <div
              key={u.id}
              class="pixel-border"
              style={{
                cursor: 'pointer',
                borderColor: selected === u.id ? 'var(--accent-green)' : undefined,
                background: selected === u.id ? 'var(--bg-panel-light)' : undefined,
                transition: 'all 0.1s',
              }}
              onClick={() => { sfx.select(); setSelected(u.id); }}
            >
              <h3 class="text-yellow" style={{ fontSize: '22px' }}>{u.name[lang] ?? u.name.en}</h3>
              <p class="text-dim" style={{ fontSize: '16px' }}>{u.description[lang] ?? u.description.en}</p>
              <p class="text-dim" style={{ fontSize: '14px' }}>Rating: {u.content_rating}</p>
            </div>
          ))}
        </div>

        <div class="mt-3" style={{ display: 'flex', gap: '1rem', justifyContent: 'space-between' }}>
          <button
            class="pixel-btn"
            onClick={() => { sfx.click(); currentScreen.value = 'auth'; }}
          >
            {tr('back')}
          </button>
          <button
            class="pixel-btn text-green"
            disabled={!selected}
            onClick={handleConfirm}
          >
            {tr('next')}
          </button>
        </div>
      </div>
    </div>
  );
}
